import React from 'react'
import '../components/primary-horizontal-card/style.scss'
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()
let ScrollMagic
if (typeof window !== 'undefined') {
  ScrollMagic = require('scrollmagic')
}

import Footer from '../components/footer'
import Header from '../components/header'
import Nav from '../components/nav'
import PrimaryHorizontalCard from '../components/primary-horizontal-card'

var controller
var numberOfCards

function pinElementBeforeFooter () {
  var lastCardHeight = document.getElementsByClassName(`primaryHorizontal-wrapper-${numberOfCards - 1}`)[0].clientHeight
  new ScrollMagic.Scene({
    triggerElement: `.primaryHorizontal-wrapper-${numberOfCards - 1}`,
    triggerHook: 0,
    duration: lastCardHeight
  })
  .setPin(`.primaryHorizontal-wrapper-${numberOfCards - 1}`, {pushFollowers: false})
  .setClassToggle('.primaryHorizontal-wrapper-slash', 'inactive')
  .addTo(controller)
}

function unfixSlash () {
  new ScrollMagic.Scene({
    triggerElement: `.primaryHorizontal-wrapper-${numberOfCards - 1}`,
    triggerHook: 0
  })
  .setClassToggle(`.primaryHorizontal-wrapper-${numberOfCards - 1}`, 'primaryHorizontal-wrapper-slash')
  .addTo(controller)
}

class IndexPage extends React.Component {
  componentDidMount () {
    if (typeof window === 'undefined') return
    if (window.innerWidth <= 1024) return
    controller = new ScrollMagic.Controller()
    unfixSlash()
    pinElementBeforeFooter()
  }

  componentWillUnmount () {
    controller = null
  }

  render () {
    const page = this.props.data.contentfulPage
    const headerTitle = md.renderInline(page.headerTitle.headerTitle)
    const companies = page.homeCompanyVignettes
    numberOfCards = companies.length
    const footer = {
      homeFooterButtonText: page.homeFooterButtonText,
      homeFooterDescription: page.homeFooterDescription.homeFooterDescription,
      homeFooterTagLine: page.homeFooterTagLine,
      homeFooterTitle: page.homeFooterTitle,
      footerCatchphrase: page.footerCatchphrase.footerCatchphrase,
      footerNav: page.footerNav
    }
    return (
      <div>
        <Nav data={page.navigationBar} primary />
        <Header
          template='home'
          bgImage={page.headerBackground.file.url}
          headingText={headerTitle}
          arrowText={page.homeArrowBlurb}
        />
        <div className='primaryHorizontal-cardsWrapper' id='mainContent'>
          {companies.map((company, i) => {
            let nextCompanyName
            if (i < companies.length - 1) {
              nextCompanyName = companies[i + 1].nameOfCompany
            }
            return (
              <PrimaryHorizontalCard key={i} company={company} nextCompanyName={nextCompanyName} index={i} />
            )
          })}
        </div>
        <Footer data={footer} primary />
      </div>
    )
  }
}

export const pageQuery = graphql`
  query HomeQuery {
    contentfulPage(pageName: {eq: "Home"}) {
      id
      navigationBar {
        id
        navigationItems {
          id
          pageName
        }
      }
      headerTitle {
        headerTitle
      }
      headerBackground {
        id
        file {
          url
          fileName
          contentType
        }
      }
      homeArrowBlurb
      homeCompanyVignettes {
        id
        nameOfCompany
        companyLogo {
          id
          file {
            url
            fileName
          }
        }
        companyDescription {
          id
          companyDescription
        }
        backgroundImage {
          id
          file {
            url
            fileName
          }
        }
      }
      homeFooterTagLine
      homeFooterDescription {
        id
        homeFooterDescription
      }
      homeFooterButtonText
      footerCatchphrase {
        id
        footerCatchphrase
      }
      footerNav {
        id
        footerCopyrights
        footerAddress
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js